import {GridTemplate} from '../types/GridTemplate';
import {GridTrack} from '../types/GridTrack';
import {getGridTrackSize} from './getGridTrackSize';

/**
 * @about Explicit track list for `Grid` `columns` / `rows`. Integers are design-system steps.
 * @example gridTracks('auto', '1fr')
 * @example gridTracks(8, gridMinmax(0, 24), 'auto')
 */
export function gridTracks(...tracks: GridTrack[]): GridTemplate {
  return {template: tracks.map(getGridTrackSize).join(' ')};
}
